import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TableColumn from "../../../components/TableColumn/TableColumn";
import api from "../../../services/api";
import TopNav from "../../../components/TopNav/TopNav";
import SideBar from "../../../components/SideBar/SideBar";

const ReviewBottleService = () => {
  const { eventsId } = useParams();
  const [reservations, setReservations] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem("ListCurrentReviewBottleService")) || 1
  );
  const records = 10;

  const columns = ["Name", "Email", "Phone", "Tier", "Price", "Redeemed"];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem("ListCurrentReviewBottleService", page);
  };

  useEffect(() => {
    const fetchData = async (page) => {
      try {
        const response = await api.get(
          `/bottle-service-admin/reservations/${eventsId}`,
          { params: { page, records } }
        );

        const items = response.data.data.map((r, i) => ({
          id: i,
          Name: r.name,
          Email: r.email || "—",
          Phone: r.phone || "—",
          Tier: r.tier,
          Price: `$${r.price}`,
          Redeemed: r.redeemed ? "Yes" : "No",
        }));

        setReservations(items);
        setTotalPages(response.data.total);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData(currentPage);
  }, [currentPage, eventsId]);

  return (
    <main>
      <TopNav />
      <div className="main-container">
        <SideBar />
        <article className="page-content">
          <section>
            <TableColumn
              title="Bottle Service Reservations"
              records={records}
              columns={columns}
              data={reservations}
              hasExport={true}
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </section>
        </article>
      </div>
    </main>
  );
};

export default ReviewBottleService;
